import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicleType: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Type',
        defaultMessage: 'Vehicle Type',
    },
    vehicleTypePlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.-- Choose Vehicle Type --',
        defaultMessage: '-- Choose Vehicle Type --',
    },   
    additionalDetails: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Additional Details',
        defaultMessage: 'Additional Details',
    },
    vehicleUsage: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Usage',
        defaultMessage: 'Vehicle Usage',
    },    
    vehicleCondition: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Condition',
        defaultMessage: 'Vehicle Condition',
    },
    vehicleMileage: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Mileage/Commute',
        defaultMessage: 'Vehicle Mileage/Commute',
    },
    safetyInformation: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Safety Information',
        defaultMessage: 'Safety Information',
    },   
    additionalInformation: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Additional Vehicle Information',
        defaultMessage: 'Additional Vehicle Information',
    },
    isTowingTrailer:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Towing a Trailer',
        defaultMessage: 'Vehicle Towing a Trailer'
    },
    funeralDirectorVehType:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Funeral Director Vehicle Type',
        defaultMessage: 'Funeral Director Vehicle Type'
    },
    numOfDays:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.No of Days',
        defaultMessage: 'No. of Days'
    },
    isTrailerSupplCarryCapcity:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Does the trailer supplement the carrying capacity of the automobile?',
        defaultMessage: 'Does the trailer supplement the carrying capacity of the automobile?'
    },
    trailerType:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Trailer Supplement',
        defaultMessage: 'Trailer Supplement'
    },
    bodyStyle:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Body Style',
        defaultMessage: 'Body Style'
    },
    isSlowMovingVehicle:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Slow Moving Vehicle',
        defaultMessage: 'Slow Moving Vehicle'
    },
    bodyType:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Trailer Type',
        defaultMessage: 'Trailer Type'
    },
    engineType:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Engine Type',
        defaultMessage: 'Engine Type'
    },
    pistonDisplacement:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Engine Displacement (cc)',
        defaultMessage: 'Engine Displacement (cc)'
    },    
    engineCylinders: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Engine Cylinders',
        defaultMessage: 'Engine Cylinders'
    },
    engineCylindersPlaceHolder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.-- Choose Engine Cylinders --',
        defaultMessage: '-- Choose Engine Cylinders --'
    },
    garagedAt:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Garaged At',
        defaultMessage: 'Garaged At'
    },
    underAgeDrivers:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Under Age Driver(s)',
        defaultMessage: 'Under Age Driver(s)'
    },
    neworUsed: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.New or Used',
        defaultMessage: 'New or Used',
    },
    neworUsedPlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.-- Choose New or Used --',
        defaultMessage: '-- Choose New or Used --',
    },
    purchasePrice: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Purchase Price',
        defaultMessage: 'Purchase Price',
    },
    purchaseDate: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Purchase Date',
        defaultMessage: 'Purchase Date',
    },
    ownershipType: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Ownership Type',
        defaultMessage: 'Ownership Type',
    },
    ownershipTypePlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.-- Choose Ownership Type --',
        defaultMessage: '-- Choose Ownership Type --',
    },    
    grossWeight:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Gross Vehicle Weight (kgs)',
        defaultMessage: 'Gross Vehicle Weight (kgs)'
    },
    odomoeterReading: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Odomoeter (kms)',
        defaultMessage: 'Odomoeter (kms)',
    },
    appraisalDate:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Appraisal Date',
        defaultMessage: 'Appraisal Date'
    },
    appraisalValue:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Appraisal Amount',
        defaultMessage: 'Appraisal Amount'
    },    
    primaryUse: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Primary Use',
        defaultMessage: 'Primary Use'
    },    
    primaryUsePlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.-- Choose Primary Use --',
        defaultMessage: '-- Choose Primary Use --'
    },
    businessPercentage: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Business Percentage',
        defaultMessage: 'Business Percentage'
    },    
    annualMileage:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Annual Kilometers',
        defaultMessage: 'Annual Kilometers'
    },
    commutingMiles:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Daily Commute Kilometres (one way)',
        defaultMessage: 'Daily Commute Kilometres (one way)'        
    },
    winterTires:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Winter Tires',
        defaultMessage: 'Winter Tires'
    },
    winterTireInstDate: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Winter Tire Installation Date',
        defaultMessage: 'Winter Tire Installation Date',
    },
    antiMarketTheftDevice:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Anti Market Theft Device',
        defaultMessage: 'Anti Market Theft Device'
    },
    farmUse: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Farm Use',
        defaultMessage: 'Farm Use',
    },
    commercialUse: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Commercial Use',
        defaultMessage: 'Commercial Use',
    },
    usExposure: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.US Exposure',
        defaultMessage: 'US Exposure',
    },
    usExposurePercent:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.US Exposure Percent',
        defaultMessage: 'US Exposure Percent'
    },    
    vehicleFuelType: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Fuel Type',
        defaultMessage: 'Vehicle Fuel Type',
    },
    vehicleFuelTypePlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.-- Choose Vehicle Fuel Type --',
        defaultMessage: '-- Choose Vehicle Fuel Type --',
    },
    vehicleCustomized: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Customized',
        defaultMessage: 'Vehicle Customized',
    },
    customizedAmount: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Customized Amount',
        defaultMessage: 'Customized Amount',
    },
    delivery:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Delivery',
        defaultMessage: 'Delivery'
    },
    useOfVehicle:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Use of Vehicle',
        defaultMessage: 'Use of Vehicle'
    },
    distanceRadius:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Radius of Operations',
        defaultMessage: 'Radius of Operations'
    },
    destinationCities:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Destination Cities',
        defaultMessage: 'Destination Cities'
    },
    seasonalDelivery:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Seasonal Delivery',
        defaultMessage: 'Seasonal Delivery'
    },
    radiusNumOfKms:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Number of Kms',
        defaultMessage: 'Number of Kms'
    },
    radiusNumOfTrips:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Number of Trips',
        defaultMessage: 'Number of Trips'
    },
    describe:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Describe',
        defaultMessage: 'Describe'
    },
    nonOwnedTrailers:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Non-Owned Trailer',
        defaultMessage: 'Non-Owned Trailer'
    },
    cvorNumber:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.CVOR Number',
        defaultMessage: 'CVOR Number'
    },
    covrRating:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.CVOR Rating',
        defaultMessage: 'CVOR Rating'
    },
    covrViolationRate:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.CVOR Violation Rate (%)',
        defaultMessage: 'CVOR Violation Rate (%)'
    },
    covrReOrderDate:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.CVOR Re-Order Date',
        defaultMessage: 'CVOR Re-Order Date'
    },
    towingVehicle:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Tows this Trailer',
        defaultMessage: 'Vehicle Tows this Trailer'
    },
    multiVehicleDiscount:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Apply Multi Vehicle Discount',
        defaultMessage: 'Apply Multi Vehicle Discount'
    },
    vehicleRateBy:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Rate By',
        defaultMessage: 'Rate By'
    },
    vehicleRateByGroup:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Group',
        defaultMessage: 'Group'
    },
    vehicleRateByValue:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Value',
        defaultMessage: 'Value'
    },
    vehicleViccCode: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.VICC Code',
        defaultMessage: 'VICC Code',
    },
    atvWheels:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Number of Wheels',
        defaultMessage: 'Number of Wheels'
    },
    vehiclebodyWeightCode: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Body Weight Code',
        defaultMessage: 'Body Weight Code',
    },
    vehicleTrailerDescription: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Trailer Description',
        defaultMessage: 'Description',
    },
    operatedOutsideProvince:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Operated Outside of Province?',
        defaultMessage: 'Operated Outside of Province?'
    },
    vehicleAppraisal:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Vehicle Appraisal',
        defaultMessage: 'Vehicle Appraisal'
    },
    customisationType:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Customization Type',
        defaultMessage: 'Customization Type'
    },
    customizationDescribe:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Description',
        defaultMessage: 'Description'
    },
    classOfUse:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Class of Use',
        defaultMessage: 'Class of Use'
    },
    commercialTrailerError: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Commercial-Trailer needs a "Vehicle that tows this trailer" to be added. Please add a supporting vehicle to proceed.',
        defaultMessage: 'Commercial-Trailer needs a "Vehicle that tows this trailer" to be added. Please add a supporting vehicle to proceed.'
    },
    touring:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Touring ?',
        defaultMessage: 'Touring ?'
    },
    moped:{
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Moped ?',
        defaultMessage: 'Moped ?'
    },
    annualBusinessDistance: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Annual Business Distance',
        defaultMessage: 'Annual Business Distance'
    },
    motorcycleType: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Motorcycle Type',
        defaultMessage: 'Motorcycle Type'
    },
    motorcycleTypePlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Choose Motorcycle Type',
        defaultMessage: '-- Choose Motorcycle Type --'
    },
    abs: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Motorcycle ABS',
        defaultMessage: 'Motorcycle ABS'
    },
    motorcycleABSPlaceholder: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Choose Motorcycle ABS',
        defaultMessage: '-- Choose Motorcycle ABS --'
    },
    absInstalled: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.Installed?',
        defaultMessage: 'Installed?'
    },
    msrp: {
        id: 'quoteandbind.rv.directives.templates.rv-vehicle.MSRP',
        defaultMessage: 'MSRP'
    },
    odometer: {
        id: 'quoteandbind.rv.directives.templates.pa-edit-vehicle.Odometer(kms)',
        defaultMessage: 'Odometer(kms)'
    },
    commercialSupplementLabel: {
        id: 'quoteandbind.rv.directives.templates.pa-edit-vehicle.Commercial Vehicle Supplement',
        defaultMessage: 'Commercial Vehicle Supplement'
    },
    numOfTimesUSedPerMonth: {
        id: "quoteandbind.RecVehProduct.fields.Model.Number of times used to commute to work per month",
        defaultMessage: "Number of times used to commute to work per month"
      },
    bikeClass: {
        id: "quoteandbind.RecVehProduct.fields.EngSiz.Bike Class",
        defaultMessage: "Bike Class"
    },
    manufacturer: {
        id: "quoteandbind.RecVehProduct.fields.EngSiz.Manufacturer",
        defaultMessage: "Manufacturer"
      },
      "content": {
        id: "quoteandbind.RecVehProduct.views.multicoverables.PRVVehLocRiskCoverableDetails.Trailer Details",
        defaultMessage: "Trailer Details"
      },
      yearBuiltTrailer: {
        id: "quoteandbind.RecVehProduct.fields.PriUse.Year Built",
        defaultMessage: "Year Built"
      },
      makeTrailer: {
        id: "quoteandbind.RecVehProduct.fields.PriUse.Make",
        defaultMessage: "Make"
      },
      modelTrailer: {
        id: "quoteandbind.RecVehProduct.fields.PriUse.Model",
        defaultMessage: "Model"
      },
      serialNumberOrVin: {
        id: "quoteandbind.RecVehProduct.fields.PriUse.Serial Number/VIN",
        defaultMessage: "Serial Number/VIN"
      }
});
